import {
  GET_OTAP_REGISTRATION_ERROR_DETAIL_API,
  SEARCH_OTAP_REGISTRATIONS_API
} from '~/constants/APIs'
import { IOtapRegistrationRequest, IOtapRegistrationResponse } from '~/models'
import axiosClient from './axiosClient'

export const otapRegistrationApis = {
  searchOtapRegistrations: (params: IOtapRegistrationRequest | null) =>
    axiosClient.get(SEARCH_OTAP_REGISTRATIONS_API, {
      params
    }) as unknown as IOtapRegistrationResponse,
  getOtapRegistrationError: (id: number) =>
    axiosClient.get(GET_OTAP_REGISTRATION_ERROR_DETAIL_API + '/' + id, {
      responseType: 'blob'
    })
}
